export function updateCurrentUser(user) {
  return {
    type: 'UPDATE_CurrentUser',
    currentUser: user
  }
}